export default __webpack_public_path__ + "img/9a4e932542296b65d6de416821932188.png";